import React from 'react';
import leafImage from '../assets/leaf.png';

// Custom styles for KnowUs component
const styles = `
.know-us-section {
    background-color: #FFFDF7;
    position: relative;
    overflow: hidden;
    padding: 50px 0;
}

/* Decorative circle with leaf - Top Right */
.know-us-section::before {
    content: '';
    position: absolute;
    top: -100px;
    right: -100px;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    background-color: rgba(47, 75, 32, 0.24);
    z-index: 1;
}

/* Decorative circle with leaf - Bottom Left */
.know-us-section::after {
    content: '';
    position: absolute;
    bottom: -100px;
    left: -100px;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    background-color: rgba(47, 75, 32, 0.24);
    z-index: 1;
}

/* Leaf overlays */
.leaf-top-right,
.leaf-bottom-left {
    position: absolute;
    width: 240px;
    height: 240px;
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 0.1;
    z-index: 2;
    pointer-events: none;
}

.leaf-top-right {
    top: -60px;
    right: -60px;
    background-position: center;
    transform: rotate(0deg);
}

.leaf-bottom-left {
    bottom: -60px;
    left: -60px;
    background-position: center;
    transform: rotate(180deg);
}

.know-us-content {
    position: relative;
    z-index: 3;
}

.know-us-heading {
    font-family: 'Quicksand', sans-serif;
    font-size: 2rem;
    font-weight: 700;
    color: #5A3411;
    margin-bottom: 10px;
}

.know-us-text {
    font-family: 'Quicksand', sans-serif;
    color: rgba(90, 52, 17, 0.8);
    font-size: 0.95rem;
    line-height: 1.5;
    margin-bottom: 12px;
}

.know-us-list {
    list-style: disc;
    padding-left: 25px;
    margin-bottom: 10px;
}

.know-us-list li {
    font-family: 'Quicksand', sans-serif;
    color: #5A3411;
    font-size: 0.95rem;
    font-weight: 600;
    line-height: 1.3;
    margin-bottom: 3px;
    -webkit-text-stroke: 0.5px #5A3411;
    text-stroke: 0.5px #5A3411;
    paint-order: stroke fill;
}

.know-us-paragraph {
    font-family: 'Quicksand', sans-serif;
    color: rgba(90, 52, 17, 0.8);
    font-size: 0.95rem;
    line-height: 1.3;
    margin-bottom: 8px;
}

/* Responsive styles */
@media (max-width: 1199.98px) {
    .know-us-section {
        padding: 45px 0;
    }
    
    .know-us-heading {
        font-size: 1.85rem;
    }
}

@media (max-width: 991.98px) {
    .know-us-section {
        padding: 40px 0;
    }
    
    .know-us-heading {
        font-size: 1.7rem;
        margin-bottom: 18px;
    }
    
    .know-us-text,
    .know-us-list li,
    .know-us-paragraph {
        font-size: 0.9rem;
    }
    
    .know-us-section::before,
    .know-us-section::after {
        width: 220px;
        height: 220px;
        top: -80px;
        right: -80px;
    }
    
    .know-us-section::after {
        top: auto;
        right: auto;
        bottom: -80px;
        left: -80px;
    }
    
    .leaf-top-right,
    .leaf-bottom-left {
        width: 190px;
        height: 190px;
    }
    
    .leaf-top-right {
        top: -50px;
        right: -50px;
    }
    
    .leaf-bottom-left {
        bottom: -50px;
        left: -50px;
    }
}

@media (max-width: 767.98px) {
    .know-us-section {
        padding: 35px 0;
    }
    
    .know-us-heading {
        font-size: 1.5rem;
        margin-bottom: 15px;
    }
    
    .know-us-text,
    .know-us-list li,
    .know-us-paragraph {
        font-size: 0.875rem;
        line-height: 1.6;
    }
    
    .know-us-text {
        margin-bottom: 10px;
    }
    
    .know-us-list {
        margin-bottom: 12px;
        padding-left: 20px;
    }
    
    .know-us-paragraph {
        margin-bottom: 6px;
    }
    
    .know-us-section::before,
    .know-us-section::after {
        width: 180px;
        height: 180px;
        top: -70px;
        right: -70px;
    }
    
    .know-us-section::after {
        top: auto;
        right: auto;
        bottom: -70px;
        left: -70px;
    }
    
    .leaf-top-right,
    .leaf-bottom-left {
        width: 150px;
        height: 150px;
    }
    
    .leaf-top-right {
        top: -45px;
        right: -45px;
    }
    
    .leaf-bottom-left {
        bottom: -45px;
        left: -45px;
    }
}

@media (max-width: 575.98px) {
    .know-us-section {
        padding: 30px 0;
    }
    
    .know-us-heading {
        font-size: 1.35rem;
        margin-bottom: 12px;
    }
    
    .know-us-text,
    .know-us-list li,
    .know-us-paragraph {
        font-size: 0.8rem;
        line-height: 1.55;
    }
    
    .know-us-text {
        margin-bottom: 8px;
    }
    
    .know-us-list {
        margin-bottom: 10px;
        padding-left: 18px;
    }
    
    .know-us-list li {
        margin-bottom: 2px;
    }
    
    .know-us-paragraph {
        margin-bottom: 5px;
    }
    
    .know-us-section::before,
    .know-us-section::after {
        width: 140px;
        height: 140px;
        top: -55px;
        right: -55px;
    }
    
    .know-us-section::after {
        top: auto;
        right: auto;
        bottom: -55px;
        left: -55px;
    }
    
    .leaf-top-right,
    .leaf-bottom-left {
        width: 120px;
        height: 120px;
    }
    
    .leaf-top-right {
        top: -35px;
        right: -35px;
    }
    
    .leaf-bottom-left {
        bottom: -35px;
        left: -35px;
    }
}

@media (max-width: 400px) {
    .know-us-section {
        padding: 25px 0;
    }
    
    .know-us-heading {
        font-size: 1.2rem;
        margin-bottom: 10px;
    }
    
    .know-us-text,
    .know-us-list li,
    .know-us-paragraph {
        font-size: 0.75rem;
        line-height: 1.5;
    }
    
    .know-us-section::before,
    .know-us-section::after {
        width: 110px;
        height: 110px;
        top: -45px;
        right: -45px;
    }
    
    .know-us-section::after {
        top: auto;
        right: auto;
        bottom: -45px;
        left: -45px;
    }
    
    .leaf-top-right,
    .leaf-bottom-left {
        width: 95px;
        height: 95px;
    }
    
    .leaf-top-right {
        top: -28px;
        right: -28px;
    }
    
    .leaf-bottom-left {
        bottom: -28px;
        left: -28px;
    }
}
`;

const KnowUs = () => {
    return (
        <>
            <style>{styles}</style>
            <section className="know-us-section">
                {/* Leaf overlays */}
                <div
                    className="leaf-top-right"
                    style={{ backgroundImage: `url(${leafImage})` }}
                ></div>
                <div
                    className="leaf-bottom-left"
                    style={{ backgroundImage: `url(${leafImage})` }}
                ></div>

                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-9">
                            <div className="know-us-content">
                                <h2 className="know-us-heading">Get to Know Us</h2>

                                <p className="know-us-text">
                                    Zubis Nursery is a family-run setting where we blend the warmth of home with the wonder of learning.
                                    We believe every child is curious, capable, and full of potential.
                                </p>

                                <p className="know-us-text">
                                    Our passionate team of educators creates an environment that encourages children to:
                                </p>

                                <ul className="know-us-list">
                                    <li>Explore and ask questions</li>
                                    <li>Think creatively and critically</li>
                                    <li>Grow in confidence and independence</li>
                                </ul>

                                <p className="know-us-paragraph">
                                    Our calm, nurturing spaces are inspired by The Curiosity Approach® and the cosy Danish concept of
                                    Hygge — creating a true home-from-home filled with warmth, comfort, and wonder.
                                </p>

                                <p className="know-us-paragraph">
                                    Soft lighting, natural materials, and authentic play resources invite children to explore, imagine, and learn
                                    through real-life experiences that spark awe, creativity, and independence.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default KnowUs;
